export default "__VITE_ASSET__780b8e48__"